import { useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export default function Faqs() {
  const { data: items = [] } = useQuery({ queryKey: ["faqs"], queryFn: () => api.get("/faqs", { params: { is_active: true, limit: 200 } }).then((r) => r.data.items) });
  const cats = useMemo(() => ["All", ...Array.from(new Set(items.map((i) => i.category).filter(Boolean)))], [items]);
  const [cat, setCat] = useState("All");
  const list = cat === "All" ? items : items.filter((i) => i.category === cat);
  return (
    <div className="pt-32 pb-24">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="text-xs uppercase tracking-[0.24em] text-amber-600 mb-4">Frequently asked</div>
        <h1 className="font-display text-5xl sm:text-6xl text-slate-950 leading-none">Questions & answers.</h1>
        <div className="mt-10 flex flex-wrap gap-2">
          {cats.map((c) => (
            <button key={c} onClick={() => setCat(c)} className={`px-4 py-2 rounded-full text-sm border ${cat === c ? "bg-slate-950 text-white border-slate-950" : "border-slate-300 text-slate-700"}`} data-testid={`faq-cat-${c}`}>{c}</button>
          ))}
        </div>
        <div className="mt-8 divide-y divide-slate-200 border-t border-slate-200">
          {list.map((f) => (
            <details key={f.id} className="py-5 group">
              <summary className="cursor-pointer flex justify-between items-center list-none"><span className="font-display text-xl text-slate-950">{f.question}</span><span className="text-amber-600 group-open:rotate-45 transition-transform">＋</span></summary>
              <p className="mt-2 text-slate-600 leading-relaxed">{f.answer}</p>
            </details>
          ))}
        </div>
      </div>
    </div>
  );
}
